export default __webpack_public_path__ + "static/helix-ps-2-3789a3606ae98140a768c8399b94100e.jpg";